import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { IconButton, TextField } from 'seagull';
import { Edit } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export const PackageNameCellContent = (param)=>{
    let { packageName, packageId, draft, setDraft } = param;
    const form = useForm({
        mode: 'all',
        defaultValues: {
            packageName
        }
    });
    const { t: editPackageNameTexts } = useLocaleKeys('pages.draftsDashboard.editPackageName');
    const onChange = (packageName)=>{
        if (!packageId) return;
        setDraft(draft.setPackageName(packageId, packageName));
    };
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
        children: /*#__PURE__*/ _jsx(Controller, {
            control: form.control,
            name: "packageName",
            rules: {
                validate: (n)=>!!n && n.length > 0
            },
            render: (renderProps)=>{
                const controllerProps = connectControllerToTextField(renderProps);
                return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                    bi: {
                        name: 'package_name'
                    },
                    collapseHelperText: false
                }, controllerProps), {
                    autoFocus: true,
                    label: editPackageNameTexts.packageName(),
                    testId: "edit-package-name-modal",
                    onChange: (e)=>{
                        onChange(e.target.value);
                        controllerProps.onChange(e);
                    }
                }));
            }
        })
    }));
};
export default function EditPackageNameButton(param) {
    let { packageName, draft, packageId, onOpenModal } = param;
    const { t: editPackageNameTexts } = useLocaleKeys('pages.draftsDashboard.editPackageName');
    const onClick = ()=>{
        onOpenModal({
            width: '400px',
            shouldSubmit: async (draft)=>{
                const bundle = draft.serviceBundles().find((bundle)=>bundle.id === packageId);
                return Promise.resolve(!!(bundle === null || bundle === void 0 ? void 0 : bundle.name) && bundle.name !== packageName);
            },
            renderContent: (param)=>{
                let { setDraft } = param;
                return {
                    title: editPackageNameTexts.packageName(),
                    testId: "edit-package-name-modal",
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(PackageNameCellContent, {
                        packageName: packageName,
                        packageId: packageId,
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    };
    return /*#__PURE__*/ _jsx(IconButton, {
        bi: {
            name: 'edit_package_name'
        },
        testId: "edit-package-name-button-".concat(packageId),
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Edit, {
            size: 18
        })
    });
}
